import infoIcon from "../../../../../assets/design-revamp-company/company-epr/epr_info_icon.svg";
import linkImg from "../../../../../assets/design-revamp-company/company-epr/epr_link_img.svg";
import "./index.css";
import { useTranslation } from "react-i18next";

export const EPRCard = () => {
  const { t } = useTranslation();
  return (
    <div className="epr-card-container">
      <img
        src={infoIcon}
        alt="Info Icon"
        width={20}
        height={20}
        className="epr-info-icon"
      />
      <h5 style={{ fontWeight: "bold" }}>ERP connect*</h5>
      <p style={{ textAlign: "center" }}>({t("AUTOFILL")})</p>
      <img src={linkImg} alt="Info Icon" width={70} height={70} />
    </div>
  );
};
